import React from 'react';
import './styles.css';
import Bup from '@BUP/assets/Images/Bup.png';

const BupLoading = () => (
	<React.Fragment>
		<div className="screen-loader-container">
			<div className="img-wrapper animation">
				<img 
					className="loading-img"
					src={Bup}
				/>
			</div>
		</div>
	</React.Fragment>
)

export default BupLoading;